/**
 * External dependencies
 */
import { get } from 'lodash';

export const getResourceConnectId = state => get(state, 'ui.resourceMetaDataModal.resourceConnectId', null);